import { render, staticRenderFns } from "./TextFieldForm.vue?vue&type=template&id=5da3951e"
import script from "./TextFieldForm.vue?vue&type=script&lang=js"
export * from "./TextFieldForm.vue?vue&type=script&lang=js"
import style0 from "./TextFieldForm.vue?vue&type=style&index=0&id=5da3951e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports